<div *ngIf="isLoading">
    <div class="loader is-active padding-leader-3 padding-trailer-3">
        <div class="loader-bars"></div>
        <div class="loader-text">Exporting Map...</div>
    </div>
</div>

<div *ngIf="mapLayers && !isLoading">
    <p class="alert alert-green is-active" *ngIf="success">
        <button type="button" class="close" (click)="resetSuccess()"><span aria-hidden="true">&times;</span></button>
        <strong>Success:</strong> Your map has been exported.
    </p>
    <label>
        File Name:
        <input type="text" [(ngModel)]="fileName" />
    </label>
    <fieldset class="fieldset-checkbox">
        <legend>
            Exportable Layers:
            <label>
                <input type="checkbox" [checked]="allChecked" [indeterminate]="someChecked" (click)="toggleCheckAll()"> Check All
            </label>
        </legend>
        <ng-template ngFor let-layer [ngForOf]="mapLayers">
            <label>
                <input type="checkbox" [checked]="layer.isChecked" (click)="checkedChange(layer)"> {{ layer.mapcoreProps.name }}
            </label>
            <ng-container *ngIf="layer.childTables && layer.childTables.length && mode === 'excel'">
                <label *ngFor="let childTable of layer.childTables" class="child">
                    <input type="checkbox" [checked]="childTable.isChecked" (click)="childCheckedChange(childTable)"> {{ childTable.layerChildRelationshipName }}
                </label>
            </ng-container>
        </ng-template>
    </fieldset>
    <fieldset *ngIf="mode === 'excel'">
        <legend>Options:</legend>
        <label style="margin-bottom: 0;">
            <input type="checkbox" [(ngModel)]="includeMapImage" /> Include Map Image
        </label>
        <label style="margin-bottom: 0;">
            <input type="checkbox" [(ngModel)]="limitToMapExtent" /> Limit to map extent
        </label>
    </fieldset>

    <div class="text-right">
        <button class="btn btn-primary" (click)="exportMap()">Export</button>
        <button class="btn" (click)="close()">Cancel</button>
    </div>
</div>
